import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../../global/util/Constant';
import {InformType} from '../../../../global/util/enum/InformType';
import {NotificationService} from '../../../service/notification.service';

@Component({
    selector: 'app-show-forward-url',
    templateUrl: './show-forward-url.component.html',
    styleUrls: ['./show-forward-url.component.css']
})
export class ShowForwardUrlComponent implements OnInit {
    hashIdentifier: string;
    people: any[] = [];
    peopleInvited: any[] = [];
    loading: boolean;

    constructor(private activeModal: NgbActiveModal,
                private notificationService: NotificationService) {
    }

    ngOnInit(): void {
    }

    resend(person: any) {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/notifications/', person.id, '/people/', this.hashIdentifier, '/documents/resend');
        this.notificationService.resend(url).subscribe(() => {
            this.loading = false;
            this.activeModal.close(InformType.Success);
        }, error => {
            this.loading = false;
            this.activeModal.close(InformType.Danger);
        });
    }

    public isOperationComplete(person: any) {
        return Constant.COMPLETED === person._more.operationCompleted;
    }

    accept() {
        this.activeModal.close();
    }
}
